import {
  ITennisCalendar,
  TennisCalendar,
} from "@sky-it-livedata/livedata-sports-design-system";
import { initAdv, injectAdv } from "@sky-uk/sky-adv";
import { HTMLAttributes, useEffect } from "react";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";

import { transformer } from "./transformers/query";
import { CalendarData } from "./types";
import { getAdvElement } from "./utils";
import { intcmpMap } from "../../utils/intcmp";

const advBoxAttributes = {
  "data-revivezoneid": "6647",
  "data-reviveid": "6609ba8ff88606794e22ff360400bcea",
  "data-state": "not-to-inject",
} as HTMLAttributes<HTMLDivElement>;

export const setCustomAttributes = ({
  variables,
}: WidgetContext<ITennisCalendar>) => {
  return { variables: JSON.stringify(variables) };
};

export function getServerProps({
  props,
}: WidgetContext<CalendarData>): ITennisCalendar {
  return transformer(props);
}

export default function Calendar({
  props,
  tag,
  ...rest
}: WidgetContext<ITennisCalendar>) {
  log({ props, tag, ...rest });

  useEffect(() => {
    const advElement = getAdvElement(tag);
    if (advElement) {
      injectAdv(advElement);
      initAdv(advElement);
    }
  }, []);

  return (
    <TennisCalendar
      {...props}
      tournaments={props.tournaments.map((tournament) => ({
        ...tournament,
        onClick: () => {
          localStorage?.setItem("intcmp", intcmpMap.calendar);
        },
      }))}
      advBoxAttributes={advBoxAttributes}
    />
  );
}
